import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image, Text } from '@fluentui/react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import goalWebsiteImg from '../media/advertising-icon.svg';
import { getTileHeaderStyles, tileStyles } from './styles';
import type { TileHeaderProps } from './types';

export function TileHeader(props: TileHeaderProps) {
  const {
    id,
    title,
    subtitle,
    displayMode,
    hideIcon,
  } = props;
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getTileHeaderStyles);

  return (
    <div className={classNames('container-header', classes.tileHeader, classes[`tileHeader-${displayMode}`])}>
      {!hideIcon &&
        <Image
          src={goalWebsiteImg}
          alt={i18n.getString(_TL_('Microsoft advertising icon'))}
          aria-hidden="true"
          width="50px"
          styles={tileStyles.image}
        />
      }
      <Text
        variant="xLarge"
        block
        className={classNames('header-title', classes.headerTitle, classes[`headerTitle-${displayMode}`])}
        as="h1"
        id={id}
      >
        {title}
      </Text>
      {subtitle}
    </div>
  );
}

TileHeader.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  displayMode: PropTypes.string,
  hideIcon: PropTypes.bool,
};

TileHeader.defaultProps = {
  id: '',
  subtitle: null,
  displayMode: '',
  hideIcon: false,
};
